module.exports = __webpack_public_path__ + "img/arrow.3e88b4df.svg";